import type { FC } from 'react';
import clsx from 'clsx';

import { useMainScreenPartContext } from '../MainScreenPartContext';
import styles from './styles.module.scss';

const Description: FC = () => {
    const { activeUser } = useMainScreenPartContext();

    if (!activeUser) return null;
    const { isSharing, name, position } = activeUser;

    const renderSecondPart = () => {
        if (isSharing) {
            return <span className={styles.demo}>Демонстрирует экран</span>;
        }

        return <span className={styles.position}>{position}</span>;
    };

    return (
        <p className={clsx(styles.description, 'text-md')}>
            <span>{name}</span>
            {renderSecondPart()}
        </p>
    );
};

export default Description;
